// Generated by bin/generate.sh
//
// This file pulls from environment variables (and git).

export default {
  "CDN": "https://komoju-fields-demo.herokuapp.com",
  "ENV": "development",
  "HONEYBADGER_API_KEY": "",
  "GIT_REV": "",
};
